import styled from "styled-components";

const RadioGroup = styled.div``;

export default RadioGroup;
